import React from 'react';

type VisaIconProps = {
  size?: number;
  className?: string;
};

const VisaIcon: React.FC<VisaIconProps> = ({ size = 36, className }) => {
  const width = size;
  const height = Math.round((size * 40) / 64);
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 64 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      {/* simple blue wordmark approximation */}
      <path d="M12 27 L16 13 L20 13 L16 27 Z" fill="#1A73E8" />
      <path d="M21 27 L23 13 L27 13 L25 27 Z" fill="#1A73E8" />
      <path d="M28 27 C28 20 37 20 37 27 L33.5 27 C33.5 24.5 31 24.5 31 27 Z" fill="#1A73E8" />
      <rect x="39" y="13" width="3" height="14" fill="#1A73E8" />
    </svg>
  );
};

export default VisaIcon;


